<div class="body" #body (scroll)="onScroll()" role="log" aria-live="polite" aria-label="Meeting transcript">
  <div class="empty" *ngIf="!lines.length && !partial" [class.warn]="!!notice">
    <span class="empty-icon" aria-hidden="true">
      <mat-icon fontSet="material-icons-outlined">{{ notice ? "info" : "subtitles" }}</mat-icon>
    </span>
    <p>No transcript yet</p>
    <span class="empty-text" *ngIf="notice">{{ notice }}</span>
    <span class="empty-text" *ngIf="!notice && enabled">Transcription has started. Words appear here as people speak (English only).</span>
  </div>

  <ng-container *ngIf="lines.length || partial">
    <p class="hint warn" *ngIf="notice">
      <mat-icon fontSet="material-icons-outlined">info</mat-icon>
      <span>{{ notice }}</span>
    </p>
    <p class="hint" *ngIf="!notice && enabled">
      <mat-icon fontSet="material-icons-outlined">subtitles</mat-icon>
      <span>Transcription has started. Words appear here as people speak (English only).</span>
    </p>
  </ng-container>

  <div class="entry" *ngFor="let line of lines; let i = index; trackBy: trackLine" [class.grouped]="!startsGroup(i)">
    <span class="avatar" *ngIf="startsGroup(i)" [style.background]="color(line.speakerId).background" [style.color]="color(line.speakerId).color" aria-hidden="true">
      {{ initials(line.speaker) }}
    </span>
    <div class="text">
      <div class="meta" *ngIf="startsGroup(i)">
        <strong>{{ line.speaker }}</strong>
        <time>{{ clock(line.at) }}</time>
      </div>
      <p>{{ line.text }}</p>
    </div>
  </div>

  <div class="entry partial" *ngIf="partial">
    <span class="avatar" [style.background]="color(partial.speakerId).background" [style.color]="color(partial.speakerId).color" aria-hidden="true">
      {{ initials(partial.speaker) }}
    </span>
    <div class="text">
      <div class="meta"><strong>{{ partial.speaker }}</strong></div>
      <p>{{ partial.text }}</p>
    </div>
  </div>
</div>
